// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users-page {
    display: flex;
    flex-direction: column;
    min-height: 100%;
}

/* Separadores (internos/externos) e filtro de estado na mesma linha. */
.users-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 16px;
}
.users-toolbar .shared-subnav { margin: 0; }
.users-count {
    display: inline-block;
    min-width: 18px;
    margin-left: 6px;
    padding: 1px 6px;
    border-radius: 999px;
    background: rgba(66, 102, 133, 0.12);
    font-size: 11px;
    font-weight: 600;
    line-height: 1.5;
    text-align: center;
}
.shared-subnav-btn.active .users-count { background: rgba(255, 255, 255, 0.22); }
.users-table td.users-empty {
    padding: 28px 14px;
    text-align: center;
    color: #718096;
}

.users-table-container {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    border: 1px solid #e2e8f0;
    overflow: hidden;
}

.users-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
}

.users-table th {
    background: #f8fafc;
    padding: 9px 14px;
    font-size: 11px;
    font-weight: 700;
    color: #4a5568;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    border-bottom: 2px solid #edf2f7;
}

.users-table td {
    padding: 10px 14px;
    border-bottom: 1px solid #edf2f7;
    font-size: 13px;
    color: #2d3748;
}

.users-table tr:last-child td {
    border-bottom: none;
}

.users-table tr:hover {
    background: #f8fafc;
}

.inactive-row {
    opacity: 0.6;
    background: #f1f5f9;
}

.role-badge {
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
}

.role-badge.admin {
    background: #fed7d7;
    color: #c53030;
}

.role-badge.user {
    background: #ebf8ff;
    color: #2b6cb0;
}

.role-badge.viewer {
    background: #fefcbf;
    color: #b7791f;
}

.status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;
}

.status-dot.active {
    background: #38a169;
}

.status-dot.inactive {
    background: #cbd5e0;
}

.actions-cell {
    display: flex;
    gap: 10px;
}

.btn-icon {
    background: none;
    border: 1px solid #e2e8f0;
    padding: 6px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-icon:hover {
    background: #edf2f7;
    border-color: #cbd5e0;
}

/* Modal styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1100;
}

.modal-content {
    background: white;
    border-radius: 12px;
    width: 90%;
    max-width: 500px;
    padding: 30px;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.modal-header h2 {
    margin: 0;
    font-size: 24px;
    color: #1a202c;
}

.modal-close {
    background: none;
    border: none;
    font-size: 24px;
    color: #a0aec0;
    cursor: pointer;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    transition: all 0.2s;
}

.modal-close:hover {
    background: #edf2f7;
    color: #2d3748;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #2d3748;
}

.form-group input,
.form-group select {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 14px;
    transition: all 0.2s;
    box-sizing: border-box;
}

.form-group input:focus,
.form-group select:focus {
    outline: none;
    border-color: #3182ce;
    box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
}

.form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
}

.modal-actions {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    margin-top: 24px;
}

.password-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
}

.password-wrapper input {
    padding-right: 40px !important;
    height: 40px !important;
    box-sizing: border-box !important;
    line-height: 40px !important;
}

.password-toggle {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    color: #a0aec0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    height: 24px;
    width: 24px;
    overflow: hidden;
    line-height: 0;
    transition: color 0.2s;
    z-index: 5;
}

.password-toggle:hover {
    color: #4a5568;
}

.password-wrapper input::-ms-reveal,
.password-wrapper input::-ms-clear {
    display: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/Utilizadores.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,uEAAuE;AACvE;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;AACA,gCAAgC,SAAS,EAAE;AAC3C;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;AACA,yCAAyC,qCAAqC,EAAE;AAChF;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,qFAAqF;AACzF;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,aAAa;AACjB","sourcesContent":[".users-page {\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-height: 100%;\r\n}\r\n\r\n/* Separadores (internos/externos) e filtro de estado na mesma linha. */\r\n.users-toolbar {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 12px;\r\n    flex-wrap: wrap;\r\n    margin-bottom: 16px;\r\n}\r\n.users-toolbar .shared-subnav { margin: 0; }\r\n.users-count {\r\n    display: inline-block;\r\n    min-width: 18px;\r\n    margin-left: 6px;\r\n    padding: 1px 6px;\r\n    border-radius: 999px;\r\n    background: rgba(66, 102, 133, 0.12);\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n    line-height: 1.5;\r\n    text-align: center;\r\n}\r\n.shared-subnav-btn.active .users-count { background: rgba(255, 255, 255, 0.22); }\r\n.users-table td.users-empty {\r\n    padding: 28px 14px;\r\n    text-align: center;\r\n    color: #718096;\r\n}\r\n\r\n.users-table-container {\r\n    background: white;\r\n    border-radius: 12px;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\r\n    border: 1px solid #e2e8f0;\r\n    overflow: hidden;\r\n}\r\n\r\n.users-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    text-align: left;\r\n}\r\n\r\n.users-table th {\r\n    background: #f8fafc;\r\n    padding: 9px 14px;\r\n    font-size: 11px;\r\n    font-weight: 700;\r\n    color: #4a5568;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.04em;\r\n    border-bottom: 2px solid #edf2f7;\r\n}\r\n\r\n.users-table td {\r\n    padding: 10px 14px;\r\n    border-bottom: 1px solid #edf2f7;\r\n    font-size: 13px;\r\n    color: #2d3748;\r\n}\r\n\r\n.users-table tr:last-child td {\r\n    border-bottom: none;\r\n}\r\n\r\n.users-table tr:hover {\r\n    background: #f8fafc;\r\n}\r\n\r\n.inactive-row {\r\n    opacity: 0.6;\r\n    background: #f1f5f9;\r\n}\r\n\r\n.role-badge {\r\n    padding: 4px 10px;\r\n    border-radius: 20px;\r\n    font-size: 11px;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.role-badge.admin {\r\n    background: #fed7d7;\r\n    color: #c53030;\r\n}\r\n\r\n.role-badge.user {\r\n    background: #ebf8ff;\r\n    color: #2b6cb0;\r\n}\r\n\r\n.role-badge.viewer {\r\n    background: #fefcbf;\r\n    color: #b7791f;\r\n}\r\n\r\n.status-dot {\r\n    width: 8px;\r\n    height: 8px;\r\n    border-radius: 50%;\r\n    display: inline-block;\r\n    margin-right: 8px;\r\n}\r\n\r\n.status-dot.active {\r\n    background: #38a169;\r\n}\r\n\r\n.status-dot.inactive {\r\n    background: #cbd5e0;\r\n}\r\n\r\n.actions-cell {\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.btn-icon {\r\n    background: none;\r\n    border: 1px solid #e2e8f0;\r\n    padding: 6px;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.btn-icon:hover {\r\n    background: #edf2f7;\r\n    border-color: #cbd5e0;\r\n}\r\n\r\n/* Modal styles */\r\n.modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 1100;\r\n}\r\n\r\n.modal-content {\r\n    background: white;\r\n    border-radius: 12px;\r\n    width: 90%;\r\n    max-width: 500px;\r\n    padding: 30px;\r\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.modal-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 24px;\r\n}\r\n\r\n.modal-header h2 {\r\n    margin: 0;\r\n    font-size: 24px;\r\n    color: #1a202c;\r\n}\r\n\r\n.modal-close {\r\n    background: none;\r\n    border: none;\r\n    font-size: 24px;\r\n    color: #a0aec0;\r\n    cursor: pointer;\r\n    padding: 0;\r\n    width: 32px;\r\n    height: 32px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 6px;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.modal-close:hover {\r\n    background: #edf2f7;\r\n    color: #2d3748;\r\n}\r\n\r\n.form-group {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.form-group label {\r\n    display: block;\r\n    margin-bottom: 8px;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    color: #2d3748;\r\n}\r\n\r\n.form-group input,\r\n.form-group select {\r\n    width: 100%;\r\n    padding: 10px 12px;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 8px;\r\n    font-size: 14px;\r\n    transition: all 0.2s;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.form-group input:focus,\r\n.form-group select:focus {\r\n    outline: none;\r\n    border-color: #3182ce;\r\n    box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);\r\n}\r\n\r\n.form-row {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 16px;\r\n}\r\n\r\n.modal-actions {\r\n    display: flex;\r\n    gap: 12px;\r\n    justify-content: flex-end;\r\n    margin-top: 24px;\r\n}\r\n\r\n.password-wrapper {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    width: 100%;\r\n}\r\n\r\n.password-wrapper input {\r\n    padding-right: 40px !important;\r\n    height: 40px !important;\r\n    box-sizing: border-box !important;\r\n    line-height: 40px !important;\r\n}\r\n\r\n.password-toggle {\r\n    position: absolute;\r\n    right: 10px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    color: #a0aec0;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 0;\r\n    height: 24px;\r\n    width: 24px;\r\n    overflow: hidden;\r\n    line-height: 0;\r\n    transition: color 0.2s;\r\n    z-index: 5;\r\n}\r\n\r\n.password-toggle:hover {\r\n    color: #4a5568;\r\n}\r\n\r\n.password-wrapper input::-ms-reveal,\r\n.password-wrapper input::-ms-clear {\r\n    display: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
